import { INITIATOR } from "modules/BookingCommon/components/DatePicker/constants"

export function getSingleOrFamilyText(isSinglePerson: boolean, initiator?: INITIATOR) {
    const singleText = initiator === INITIATOR.PSYCHOLOGIST ? "индивидуально" : "только вы"
    return isSinglePerson ? singleText : "с партнером/семьей"
}
